<template lang='pug'>
  v-flex(:class="classObj", :title='label')
    div(:class='`size-3`')
      .caption.pb-2 {{ label }}
      tinymce-editor(
        v-model="dataText"
        :api-key="apiKey"
        :init="initObj"
        :toolbar="toolbar"
        id="editor"
        )
      TemplateDialog(
        v-model="templateDialogShow"
        @apply="applyTemplate"
      )
</template>

<script>
import { mapState } from 'vuex'
import { db } from '@/store/firebase'
import TemplateDialog from '@/components/editor/TemplateDialog'
import print from '@/utils/printTables'
// import _ from 'lodash'

export default {
  name: 'u-rich-text-editor',

  components: {
    TemplateDialog
  },

  props: {
    id: {
      type: String
    },
    component: {
      type: Object,
      required: true
    },
    value: {
      default: ''
    },
    resultForm: {
      type: Object
    },
    fillTemplate: {
      type: Function
    },
    suggestConclusion: {
      type: Function
    }
  },

  computed: {
    label () {
      return this.t(this.id + '.label', this.component.label)
    },
    btnLabel () {
      return this.maskReport.model ? 'salvar' : 'novo'
    },
    ...mapState({
      formJSON: (state) => state.ultraFetal.formJSON,
      templates: state => state.ultraFetal.templates,
      gestationInteraction: (state) => state.ultraFetal.gestationInteraction
    })
  },

  watch: {
    value (val) {
      // if (!this.ready) return
      if (this.dataText === val) return
      this.dataText = val
    },
    dataText (val) {
      this.$emit('input', val)
    },
    'maskReport.search' () {
      this.fetchMaskReport()
    },
    'maskReport.model' (val) {
      if (!val) return
      this.datdataTexta = val.content
      // this.maskReport.model = null
    }
  },

  data () {
    return {
      dataText: '',
      maskReport: {
        model: null,
        items: [],
        search: null,
        isLoading: false
      },
      templateDialogShow: false,
      editor: null,
      apiKey: process.env.TINYMCE_API_KEY,
      // toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment',
      toolbar: 'fullscreen | suggestConclusion reportTemplates insertKeyWord | undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment',
      initObj: {
        menubar: false,
        statusbar: false,
        min_height: 480,
        paste_data_images: true,
        plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen pagebreak',
          'insertdatetime media table paste code help wordcount'
        ],
        setup: async (editor) => {
          const vm = this
          let listValue = []
          let keyPosition = 1
          let keyLength = 0
          let formsValue
          print.dataToTable(this.formJSON, this.gestationInteraction.forms).then(function (value) {
            formsValue = value
          }, function (error) {
            console.log('erro: ', error)
          })
          editor.ui.registry.addAutocompleter('specialchars', {
            ch: '@',
            minChars: 0,
            columns: 1,
            fetch: function (pattern) {
              const patternUpper = pattern.toUpperCase()

              // Separa templates da empresa e do sistema
              const companyTemplates = vm.templates.filter(template => {
                return !template.isSystem &&
                       template.name.toUpperCase().indexOf(patternUpper) !== -1
              })

              const systemTemplates = vm.templates.filter(template => {
                return template.isSystem &&
                       template.name.toUpperCase().indexOf(patternUpper) !== -1
              })

              // Prepara os resultados dos templates
              const templateResults = [
                // Adiciona cabeçalho para templates da empresa
                ...(companyTemplates.length ? [{
                  type: 'separator',
                  value: 'separator-company',
                  text: 'Modelos da Empresa'
                }] : []),
                // Adiciona templates da empresa
                ...companyTemplates.map(char => ({
                  value: `templates/${char.iuid}/contents/${char.currentContent}`,
                  text: char.name
                })),
                // Adiciona cabeçalho para templates do sistema
                ...(systemTemplates.length ? [{
                  type: 'separator',
                  value: 'separator-system',
                  text: 'Modelos do Sistema'
                }] : []),
                // Adiciona templates do sistema
                ...systemTemplates.map(char => ({
                  value: `templates/${char.iuid}/contents/${char.currentContent}`,
                  text: '> ' + char.name // Ícone para identificar templates do sistema
                }))
              ]

              // Prepara os campos do formulário
              const formFields = []
              for (const position in formsValue) {
                if (formsValue[position].form === 'Conclusão' || formsValue[position].panel === 'Gráficos') continue
                listValue[formsValue[position].key] = formsValue[position].value
                let formText = '# ' + formsValue[position].form + ' > ' + formsValue[position].panel + ' > ' + formsValue[position].comp
                if (formsValue[position].itemLabel) formText += ' > ' + formsValue[position].itemLabel
                if (formText.toUpperCase().indexOf(patternUpper.replace('#', '')) !== -1) {
                  formFields.push({
                    value: '#' + formsValue[position].key,
                    text: formText
                  })
                }
              }

              // Adiciona separador para medidas somente se houver campos
              if (formFields.length > 0) {
                templateResults.push({
                  type: 'separator',
                  value: 'separator-measurements',
                  text: 'Informações e Medidas'
                })
              }

              return new window.tinymce.util.Promise(function (resolve) {
                resolve([...templateResults, ...formFields])
              })
            },
            onAction: async function (autocompleteApi, rng, value) {
              editor.selection.setRng(rng)
              if (value.startsWith('#')) {
                const key = value.replace('#', '')
                let formValue = listValue[key] || 'Não informado'
                editor.insertContent(`<span id="${key}">${formValue}</span>`)
                autocompleteApi.hide()
              } else {
                autocompleteApi.hide()
                const query = await db.doc(value).get()
                if (query.exists) {
                  let template = query.data().body
                  if (vm.fillTemplate) {
                    template = await vm.fillTemplate(template)
                  }
                  editor.insertContent(template)
                }
              }
            }
          })
          if (vm.suggestConclusion) {
            editor.ui.registry.addButton('suggestConclusion', {
              text: 'IA',
              tooltip: 'sugerir laudo por IA',
              // icon: 'ai-prompt',
              onAction: async () => (this.applySuggestConclusion())
            })
          }
          editor.ui.registry.addButton('reportTemplates', {
            text: 'Modelos',
            onAction: () => (this.templateDialogShow = true)
          })
          editor.addShortcut('alt+1', 'Find Keyword', function () {
            if (keyLength !== (editor.dom.select('span.key').length - 1)) {
              keyLength = (editor.dom.select('span.key').length - 1)
              keyPosition--
            }
            if (keyPosition > (editor.dom.select('span.key').length - 1)) keyPosition = 0
            editor.selection.select(editor.dom.select('span.key', 'body')[keyPosition], true)
            keyPosition++
          })
          editor.ui.registry.addMenuButton('insertKeyWord', {
            text: 'Sugestões',
            fetch: function (callback) {
              var items = []
              var allItemsText = ''
              var cont = 1
              for (const position in formsValue) {
                if (formsValue[position].percentil && (formsValue[position].percentil >= 0.95 || formsValue[position].percentil <= 0.05)) {
                  let percentilValue
                  if (formsValue[position].percentil > 0.95) percentilValue = 'acima de P95 '
                  if (formsValue[position].percentil < 0.05) percentilValue = 'abaixo de P5 '
                  if (formsValue[position].comp && formsValue[position].comp.startsWith('Peso estimado')) {
                    formsValue[position].comp = 'Peso estimado'
                    if (formsValue[position].percentil < 0.03) percentilValue = 'abaixo de P3 '
                    if (formsValue[position].percentil > 0.03 && formsValue[position].percentil < 0.1) percentilValue = ' P' + Math.round(formsValue[position].percentil * 100) + ' '
                    if (formsValue[position].percentil > 0.98) percentilValue = 'acima de P98 '
                    if (formsValue[position].percentil < 0.98 && formsValue[position].percentil > 0.75) percentilValue = ' P' + Math.round(formsValue[position].percentil * 100) + ' '
                  }
                  allItemsText += (formsValue[position].comp + ': ' + percentilValue + '<br>')
                  let searchText = formsValue[position].form + ' > ' + formsValue[position].panel + ' > ' + formsValue[position].comp
                  if (formsValue[position].itemLabel) searchText += ' > ' + formsValue[position].itemLabel
                  searchText += ' > ' + percentilValue
                  items[cont] = {
                    type: 'menuitem',
                    text: searchText,
                    onAction: function () {
                      editor.insertContent(formsValue[position].comp + ': ' + percentilValue)
                      // this.fetch()
                    }
                  }
                  cont++
                }
                if (formsValue[position].value && (formsValue[position].value === 'incerto' || formsValue[position].value === 'alterado')) {
                  let stateValue
                  if (formsValue[position].value === 'incerto') {
                    stateValue = 'incerto'
                  } else {
                    stateValue = 'alterado'
                  }
                  allItemsText += (formsValue[position].comp + ': valor ' + stateValue + '<br>')
                  let searchText = formsValue[position].form + ' > ' + formsValue[position].panel + ' > ' + formsValue[position].comp
                  if (formsValue[position].itemLabel) searchText += ' > ' + formsValue[position].itemLabel
                  searchText += ' > ' + stateValue
                  items[cont] = {
                    type: 'menuitem',
                    text: searchText,
                    onAction: function () {
                      editor.insertContent(formsValue[position].comp + ': valor ' + stateValue)
                      this.fetch()
                    }
                  }
                  cont++
                }
              }
              items[0] = {
                type: 'menuitem',
                text: 'TODOS',
                onAction: function () {
                  editor.insertContent(allItemsText)
                }
              }
              callback(items)
            }
          })
          editor.on('init', function () {
            const editorContainer = document.querySelector('.tox.tox-tinymce')
            if (editorContainer) {
              editorContainer.style.height = 'calc(100vh - 250px)'

              const sidebarWrap = editorContainer.querySelector('.tox-sidebar-wrap')
              if (sidebarWrap) {
                sidebarWrap.style.height = 'calc(100% - 39px)'
              }

              const editArea = editorContainer.querySelector('.tox-edit-area')
              if (editArea) {
                editArea.style.height = '100%'
              }

              const iframe = editorContainer.querySelector('.tox-edit-area__iframe')
              if (iframe) {
                iframe.style.height = '100%'
              }
            }
          })
        }
      }
    }
  },

  mounted () {
    // if (this.component.size) this.editorConfig.size = this.component.size
  },

  methods: {
    async applyTemplate (payload) {
      let template = payload
      if (this.fillTemplate) {
        template = await this.fillTemplate(template)
      }
      tinymce.get('editor').insertContent(template) // eslint-disable-line no-undef
    },
    async applySuggestConclusion () {
      if (this.suggestConclusion) {
        const template = await this.suggestConclusion()
        tinymce.get('editor').insertContent(template) // eslint-disable-line no-undef
      }
    }
  }
}
</script>

<style lang='stylus' scoped>
:deep(.tox-tinymce)
  display: flex
  flex-direction: column

:deep(.tox-sidebar-wrap)
  flex: 1
  display: flex
  flex-direction: column

:deep(.tox-edit-area)
  flex: 1
  display: flex
  flex-direction: column

:deep(.tox-edit-area__iframe)
  flex: 1
</style>



// WEBPACK FOOTER //
// src/components/form/inputs/RichTextEditor.vue